// extracted by mini-css-extract-plugin
export default {"root":"EditOrderModal_root__NzZUd"};